var _style, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path10, _ellipse6, _ellipse7, _path11, _ellipse8, _path12, _ellipse9, _path13, _path14, _path15, _ellipse10, _ellipse11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.78,322.73c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57L357.1,57.99 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L178.01,314.74C172.7,320.07,165.74,322.73,158.78,322.73z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.19,
    cy: 159.09,
    rx: 27.19,
    ry: 27.27
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.19,513.63c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l108.78-109.09 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L96.42,505.65C91.11,510.97,84.15,513.63,77.19,513.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.19,731.82c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l108.78-109.09 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L96.42,723.83C91.11,729.16,84.15,731.82,77.19,731.82z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.19,840.91c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l217.55-218.18 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L96.42,832.92C91.11,838.25,84.15,840.91,77.19,840.91z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.19,950c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l108.78-109.09c10.62-10.65,27.84-10.65,38.46,0 c10.62,10.65,10.62,27.92,0,38.57L96.42,942.01C91.11,947.34,84.15,950,77.19,950z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.97,513.63c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l108.78-109.09 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L205.2,505.65C199.89,510.97,192.93,513.63,185.97,513.63z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75,950c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l108.78-109.09 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L313.98,942.01C308.67,947.34,301.71,950,294.75,950z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M403.52,404.54c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57L493.07,248.9 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L422.75,396.56C417.44,401.88,410.48,404.54,403.52,404.54z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.52,
    cy: 595.45,
    rx: 27.19,
    ry: 27.27
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.52,
    cy: 704.55,
    rx: 27.19,
    ry: 27.27
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.52,
    cy: 922.73,
    rx: 27.19,
    ry: 27.27
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 512.3,
    cy: 377.27,
    rx: 27.19,
    ry: 27.27
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M512.3,950c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l383.31-384.42c10.62-10.65,27.84-10.65,38.46,0 c10.62,10.65,10.62,27.92,0,38.57L531.53,942.01C526.22,947.34,519.26,950,512.3,950z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.08,
    cy: 486.36,
    rx: 27.19,
    ry: 27.27
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.85,
    cy: 159.09,
    rx: 27.19,
    ry: 27.27
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M729.85,513.63c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l192.95-193.51 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L749.08,505.65C743.77,510.97,736.81,513.63,729.85,513.63z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.85,
    cy: 595.45,
    rx: 27.19,
    ry: 27.27
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M729.85,840.91c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57L819.4,685.26 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L749.08,832.92C743.77,838.25,736.81,840.91,729.85,840.91z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.85,
    cy: 922.73,
    rx: 27.19,
    ry: 27.27
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M838.63,186.36c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l81.58-81.82 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57l-81.58,81.82C852.55,183.7,845.59,186.36,838.63,186.36z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M838.63,950c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57l81.58-81.82c10.62-10.65,27.84-10.65,38.46,0 c10.62,10.65,10.62,27.92,0,38.57l-81.58,81.82C852.55,947.34,845.59,950,838.63,950z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M512.3,213.64c-6.96,0-13.92-2.66-19.23-7.99c-10.62-10.65-10.62-27.92,0-38.57L601.85,57.99 c10.62-10.65,27.84-10.65,38.46,0c10.62,10.65,10.62,27.92,0,38.57L531.53,205.65C526.22,210.97,519.26,213.64,512.3,213.64z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.48,
    cy: 595.45,
    rx: 27.19,
    ry: 27.27
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 922.81,
    cy: 705.26,
    rx: 27.19,
    ry: 27.27
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP8);
export default __webpack_public_path__ + "static/media/P8.5a501bc0fde59f860666bccf32619270.svg";
export { ForwardRef as ReactComponent };